import React from 'react';
import api from '../services/api';
import KriticalWatching from './KriticalWatching';

const NewKriticalMovies = ({ user, onRatingUpdate, lastUpdate }) => (
  <KriticalWatching
    user={user}
    onRatingUpdate={onRatingUpdate}
    lastUpdate={lastUpdate}
    title="New Kritical Movies"
    titleLink="/new-kritical-movies"
    tooltip="Movies out in the past 30 days or coming in the next 30, with a 4/5+ average from Kritics who match you 7/10+."
    getRecommendations={api.getNewKriticalMovies}
    showStarterExperience={false}
    keepWannaWatch
    emptyMessage="No movies in the current release window meet these match and rating criteria yet."
  />
);

export default NewKriticalMovies;
